import * as Popover from '@radix-ui/react-popover';
import { useState } from 'react';

import { PresenceList } from 'components/presence/components/presenceList';
import { UsePresenceMembersResult } from 'components/presence/hooks/usePresenceMembers';

import { SidebarFooterButton } from '../footer/components/button/sidebarFooterButton';

import styles from './teamPresencePopover.module.scss';

type TeamPresencePopoverProps = {
  presenceMembers: UsePresenceMembersResult;
  onAddAgent?: () => void;
};

export const TeamPresencePopover = ({
  presenceMembers,
  onAddAgent,
}: TeamPresencePopoverProps): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover.Root open={isOpen} onOpenChange={setIsOpen}>
      <Popover.Trigger asChild>
        <SidebarFooterButton icon="user-status" aria-label="Team" />
      </Popover.Trigger>

      <Popover.Portal>
        <Popover.Content
          className={styles.popover}
          side="right"
          align="end"
          sideOffset={4}
          collisionPadding={8}
          onOpenAutoFocus={(event) => event.preventDefault()}
        >
          <PresenceList
            presenceMembers={presenceMembers}
            onAddAgent={onAddAgent}
          />
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};
